import { Route, Routes } from 'react-router-dom';
import { Message } from "@aws-amplify/ui-react";


interface Props {
  children: JSX.Element[] | JSX.Element;
}
function RoutesWithNotFound({ children }: Props) {
  return (
    <Routes>
      {children}
      <Route path="*" element={
        <Message
        variation="filled"
        colorTheme="warning"
        textAlign={"center"}
        hasIcon={false}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          width: '30%',  // Ajusta el ancho según sea necesario
          padding: '1rem',
          margin: 'auto',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          position: 'absolute',
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        You don't have permission to access this page
      </Message>} />
    </Routes>
  );
}
export default RoutesWithNotFound;
